
import { useContext, useEffect, useRef, useState } from 'react';
import { SongContext } from '../../../Routes/Routes1';
import Control from '../../control/Control';
import './music-player.css'


export default function MusicPlayer(){
    const {songs}=useContext(SongContext)
    const [isPlaying,setPlaying]=useState(false)
    const audio=useRef(null)


    useEffect(()=>{
        
        if(isPlaying) 
        { 
            audio.current.play()
        }
        else{
            audio.current.pause()
        }
    },[isPlaying,songs])
    
   
    
    return(
        <div className="row footerLine fixed-bottom">
            <div className="col-lg-4 col-md-5 col-sm-6 col-4">
                <img id="csx" src={songs.sImage} alt="..."/>
                <span style={{fontSize:'2vh'}}>{songs.sName}</span>
            </div>
            <div className="col-lg-4 col-md-5 col-sm-6 col-8 p-1">
                <audio src={songs.song} ref={audio} type="audio/mpeg"></audio>
                <Control 
                    isPlaying={isPlaying} 
                    setPlaying={setPlaying} 
                    audio={audio}
                />  
            </div>
            <div className="col-lg-4 col-md-2"></div>
        </div>
    );
}



// div className="row footerLine fixed-bottom">
//             <div className="col-lg-4 col-md-6 col-sm-6 col-4">
//                 <img id="csx" src={songs.sImage} alt="..."/>
//                 <span>{songs.sName}</span>
//             </div>
//             <div className="col-lg-4 col-md-4 col-sm-6 col-8 p-1">
//                 <center>
//                     <audio id='Myaudio' controls autoPlay>
//                         <source src={songs.song} type="audio/mpeg"/>
//                     </audio>
//                 </center>
//             </div>
//             <div className="col-lg-4 col-md-2"></div>
//         </div>